import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { TRIAL_PRICING_PATH } from "@/lib/connectTrial";

export default function TrialReminderDialog({ open, daysRemaining, onDismiss }) {
  const navigate = useNavigate();
  const days = daysRemaining != null ? daysRemaining : null;
  const dayLabel = days == null
    ? "A few days left"
    : days === 1
      ? "1 day left"
      : `${days} days left`;

  const goSubscribe = () => {
    onDismiss?.();
    navigate(TRIAL_PRICING_PATH);
  };

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onDismiss?.(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="w-10 h-10 rounded-lg bg-blue-500 flex items-center justify-center mb-2">
            <Clock className="h-5 w-5 text-white" />
          </div>
          <DialogTitle className="text-xl">
            {dayLabel} on your SparkSeller Connect trial
          </DialogTitle>
          <DialogDescription className="text-sm leading-relaxed pt-1">
            Add a credit card and activate a subscription before your trial ends
            to keep full access — and get <strong className="text-foreground">10% off</strong> monthly
            or annual.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onDismiss}>
            Maybe later
          </Button>
          <Button className="bg-blue-600 hover:bg-blue-700" onClick={goSubscribe}>
            Subscribe and save 10%
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
